import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const GetBookingsTransactions = createAsyncThunk('appCardtransactions/GetBookingsTransactions', async (params) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Client/BookingsTransactions', params, {mode:'cors'})
       
      return response.data 
      })

      export const getPaymentType = createAsyncThunk('appCardtransactions/getPaymentType', async (params) => {
        const response = await axios.post('https://api.zasway.com:8443/Client/GetPaymentType', params)
          return response.data
      })

      export const GetInvoiceTransactions = createAsyncThunk('appCardtransactions/GetInvoiceTransactions', async (params) => {
         
        const response = await axios.post('https://api.zasway.com:8443/Client/InvoiceTransactions', params, {mode:'cors'})
        return response.data 
    
        })
    
      export const GetPaymentStatus = createAsyncThunk('appCreditCardsBooking/GetPaymentStatus ', async (params) => {
            const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/GetPaymentStatus', params, { mode: 'cors' })
           return response.data
           })
     
        export const getClientList = createAsyncThunk('appCreditCardsBooking/getClientList', async () => {
          const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList')
          return response.data
        })

  export const appCardTransactionsSlice = createSlice({
    name: 'appCardtransactions',
    initialState: {
      data: [],
      allData: [],
      cardtransactiondata: [],
      invoicetransactiondata: [],
      FinanceInfoBookingData: []
     
    },
    reducers: {},
    extraReducers: builder => {
      builder
 
      .addCase(GetBookingsTransactions.fulfilled, (state, action) => {
         
        state.cardtransactiondata = action.payload
     })
     .addCase(GetInvoiceTransactions.fulfilled, (state, action) => {
       
        state.invoicetransactiondata = action.payload
     })
    }
  })
   export default appCardTransactionsSlice.reducer

